<template lang='pug'>
.not-found-container.fill
  h1 Not Found

  .logo
    <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 100 100' style='enable-background:new 0 0 100 100;' xml:space='preserve'>
      <g>
        <path d='M68,69.1l0-5.4l-3.6-0.9c-0.3-1.2-0.8-2.4-1.4-3.5l1.9-3.2l-3.8-3.9l-3.2,1.9c-1.1-0.6-2.2-1.1-3.5-1.5l-0.9-3.6L48,49l-0.9,3.6c-1.2,0.3-2.4,0.8-3.5,1.4l-3.2-1.9L36.6,56l1.9,3.2c-0.6,1.1-1.1,2.2-1.5,3.5l-3.6,0.9l0,5.5l3.6,0.9c0.3,1.2,0.8,2.4,1.4,3.5l-1.9,3.2l3.8,3.9l3.2-1.9c1.1,0.6,2.2,1.1,3.5,1.5l0.9,3.6l5.5,0l0.9-3.6c1.2-0.3,2.4-0.8,3.5-1.4l3.2,1.9l3.9-3.8l-1.9-3.2c0.6-1.1,1.1-2.2,1.5-3.5L68,69.1z M50.7,76c-5.3,0-9.7-4.4-9.6-9.7c0-5.3,4.4-9.7,9.7-9.6c5.3,0,9.7,4.4,9.6,9.7C60.4,71.7,56,76,50.7,76z'/>
        <path d='M70.1,56c3.4,6.6,3.4,14.8-0.8,21.5c-4,6.5-11,10.4-18.7,10.4c-4,0-8-1.1-11.4-3.2C28.9,78.4,25.7,64.9,32,54.6c4-6.5,11-10.4,18.7-10.4c2.8,0,5.6,0.6,8.2,1.6l-0.3,0.6l-0.9,1.5c-0.8,1.2-0.3,2.3,1.1,2.3l11.4,0.4c1.3,0.1,1.9-0.9,1.2-2l-5.6-9.9c-0.7-1.2-1.8-1.1-2.6,0.1l-1,1.7l-0.3,0.5c-3.6-1.6-7.4-2.4-11.2-2.4c-9.3,0-18.3,4.7-23.5,13.1c-8,13-3.9,29.9,9,37.9c4.5,2.8,9.5,4.1,14.4,4.1c9.3,0,18.3-4.7,23.5-13.1c4.7-7.6,5.2-16.6,2.2-24.3L70.1,56z'/>
        <path d='M92.3,38.4L92.3,38.4L92.3,38.4c-1.1-0.5-2.2-0.7-3.3-0.9c-1.2-5.9-5.2-11.2-11.2-13.8c-2.5-1.1-5.1-1.6-7.6-1.6c-1.9,0-3.7,0.3-5.5,0.8C62.6,16.7,58,11.4,51.5,8.5c-3.1-1.3-6.3-2-9.5-2C32.8,6.6,24,12,20.1,21c-0.6,1.3-1,2.6-1.3,3.9c-0.1,0-0.1,0-0.2,0c-6.9,0-13.5,4-16.5,10.8c-1,2.3-1.5,4.7-1.5,7.1c0,6.9,4,13.5,10.8,16.5c2.2,1,4.6,1.4,6.9,1.5l0,0h0.2c0.3-1.6,0.7-3.1,1.1-4.6h-1c0,0-0.1,0-0.1,0h0c-1.8,0-3.5-0.3-5.3-1.1c-5-2.2-8-7.1-8-12.2c0-1.8,0.4-3.6,1.1-5.3c2.2-5,7.1-8,12.2-8c0.6,0,1.2,0,1.8,0.1l2.3,0.3l0.3-2.3c0.2-1.7,0.7-3.3,1.4-4.8c3.1-7.3,10.2-11.6,17.7-11.6c2.6,0,5.1,0.5,7.7,1.6c5.9,2.6,9.9,7.8,11.2,13.6l0.6,2.8L64,28c1.9-0.9,4-1.3,6.1-1.3c1.9,0,3.9,0.4,5.8,1.2c5.1,2.2,8.3,6.9,8.8,12.1l0.2,2.3l2.3-0.2c0.2,0,0.4,0,0.6,0c0.9,0,1.8,0.2,2.7,0.5c2.6,1.1,4.2,3.7,4.2,6.4c0,0.9-0.2,1.8-0.6,2.8c-1,2.4-3.3,4.1-5.6,4.4l-7,0c0.5,1.5,0.9,3.1,1.2,4.6h6l0.1,0c4.2-0.4,7.8-3.2,9.5-7.1c0.6-1.5,1-3.1,1-4.6C99.3,44.5,96.7,40.3,92.3,38.4z'/>
      </g>
    </svg>
</template>

<style lang='scss'>
  @use '@printos/agnostic-styles/src/mixins' as *;

  .not-found-container {
    @include flex-column(center, center);
  }

  .logo {
    width: 400px;
    max-width: 100%;

    color: $hp-blue;
    fill: $hp-blue;
  }

  body[pos--theme='dark'] {
    .not-found-container {
    }
  }
</style>

